import L from 'leaflet';

const normalizeInfraKriteria = (value) => (String(value || 'live').trim().toLowerCase() === 'plan' ? 'plan' : 'live');

const getTheme = (kriteria) => {
  const category = normalizeInfraKriteria(kriteria);
  if (category === 'plan') {
    return {
      category,
      accent: '#f59e0b',
      glow: 'rgba(245, 158, 11, 0.35)',
      body: 'rgba(8, 8, 8, 0.94)',
      detail: 'rgba(255, 255, 255, 0.14)',
      detailStrong: 'rgba(245, 158, 11, 0.30)',
      label: 'PLAN',
    };
  }

  return {
    category,
    accent: '#3b82f6',
    glow: 'rgba(59, 130, 246, 0.34)',
    body: 'rgba(8, 8, 8, 0.94)',
    detail: 'rgba(255, 255, 255, 0.14)',
    detailStrong: 'rgba(59, 130, 246, 0.30)',
    label: 'LIVE',
  };
};

const buildSvg = (nodeType, theme) => {
  if (nodeType === 'olt') {
    return `<svg width="46" height="46" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="11" y="7" width="26" height="34" rx="7" fill="${theme.body}" stroke="${theme.accent}" stroke-width="2.3" />
      <rect x="16" y="13" width="16" height="4" rx="2" fill="${theme.detailStrong}" />
      <rect x="16" y="21" width="16" height="3" rx="1.5" fill="${theme.detail}" />
      <circle cx="18" cy="31" r="2.1" fill="${theme.accent}" />
      <circle cx="24" cy="31" r="2.1" fill="${theme.accent}" />
      <circle cx="30" cy="31" r="2.1" fill="${theme.accent}" />
    </svg>`;
  }

  return `<svg width="46" height="46" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="10" y="12" width="28" height="20" rx="5" fill="${theme.body}" stroke="${theme.accent}" stroke-width="2.3" />
    <path d="M24 32V39" stroke="${theme.accent}" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M17 39H31" stroke="${theme.accent}" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18 19H30" stroke="${theme.accent}" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M24 19V26" stroke="${theme.accent}" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M24 26L16 30" stroke="${theme.accent}" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M24 26L32 30" stroke="${theme.accent}" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" />
    <circle cx="16" cy="30" r="2" fill="${theme.accent}" />
    <circle cx="24" cy="26" r="2" fill="${theme.accent}" />
    <circle cx="32" cy="30" r="2" fill="${theme.accent}" />
  </svg>`;
};

export const createInfraNodeIcon = (type, kriteria) => {
  const nodeType = String(type || 'odp').trim().toLowerCase() === 'olt' ? 'olt' : 'odp';
  const theme = getTheme(kriteria);
  const label = nodeType.toUpperCase();
  const svg = buildSvg(nodeType, theme);

  const markerStyle = [
    'position:relative',
    `width:${nodeType === 'olt' ? 54 : 52}px`,
    `height:${nodeType === 'olt' ? 66 : 62}px`,
    'display:flex',
    'align-items:center',
    'justify-content:center',
    `filter:drop-shadow(0 8px 14px ${theme.glow}) drop-shadow(0 6px 12px rgba(0,0,0,0.42))`,
    'pointer-events:auto',
  ].join(';');

  const labelStyle = [
    'position:absolute',
    `bottom:${nodeType === 'olt' ? 1 : 2}px`,
    'left:50%',
    'transform:translateX(-50%)',
    'min-width:32px',
    'padding:2px 7px',
    'border-radius:9999px',
    'background:rgba(5,5,5,0.94)',
    `border:1px solid ${theme.accent}`,
    'color:#ffffff',
    'font-size:10px',
    'line-height:1',
    'font-weight:700',
    'letter-spacing:.08em',
    'text-align:center',
  ].join(';');

  return L.divIcon({
    className: 'infra-node-wrapper',
    html: `<div style="${markerStyle}">${svg}<span style="${labelStyle}">${label}</span></div>`,
    iconSize: nodeType === 'olt' ? [54, 66] : [52, 62],
    iconAnchor: nodeType === 'olt' ? [27, 58] : [26, 54],
    popupAnchor: [0, -48],
  });
};

export const getInfraNodePreviewClassName = (type, kriteria) => {
  const nodeType = String(type || 'odp').trim().toLowerCase() === 'olt' ? 'olt' : 'odp';
  const category = normalizeInfraKriteria(kriteria);
  return `infra-node-preview infra-node-${nodeType} infra-node-${category}`;
};
